module.exports = __webpack_public_path__ + "static/media/1.d3ab7676.jpg";